import {createBrowserRouter, Navigate} from "react-router";
import AppRoute from "./AppRoute";
import App from "../App";
import CityPinner from "../components/projects/CityPinner";
import Oncruiter from "../components/projects/Oncruiter";
import CVApp from "../components/projects/CVApp";
import ASC from "../components/projects/ASC";
import Atlas from "../components/projects/Atlas";
import Chiron from "../components/projects/Chiron";

const router = createBrowserRouter([
    {
        path: AppRoute.HOME,
        element: <App/>,
    },
    {
        path: AppRoute.CITY_PINNER,
        element: <CityPinner/>,
    },
    {
        path: AppRoute.CV_APP,
        element: <CVApp/>,
    },
    {
        path: AppRoute.ONCRUITER,
        element: <Oncruiter/>,
    },
    {
        path: AppRoute.ASC,
        element: <ASC/>
    },
    {
        path: AppRoute.ATLAS,
        element: <Atlas/>
    },
    {
        path: AppRoute.CHIRON,
        element: <Chiron/>
    },
    {
        path: "*",
        element: <Navigate to={AppRoute.HOME} replace/>
    }
]);

export default router;